module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970/0135.jpg?v=1716cc0f";